import React from 'react';
import { useSelector } from 'react-redux';

// Types
import { ReviewState } from 'Shared/types/Review.type';
import { ReviewTemplateTypeType } from 'Shared/types/ReviewTemplates.type';

// Hooks
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

// Selectors
import * as ReviewsSelectors from 'Shared/selectors/Reviews.selectors';

// Utils
import * as ReviewsUtils from 'Shared/utils/Reviews.utils';

// Components
import CoachingPageHeader from '../_partials/CoachingPageHeader';
import ReviewsCardsContainer from 'Shared/components/ReviewsCardsContainer/ReviewsCardsContainer';
import EmptyStateContainer from 'Shared/components/EmptyStateContainer/EmptyStateContainer';

const PastReviews = () => {
  const { user: currentUser } = useCurrentUser();

  const sharedAndCompletedReviews = useSelector(state =>
    ReviewsSelectors.getReviewsByStatus(state, {
      status: [ReviewState.SHARED, ReviewState.COMPLETED],
      reviewTemplateType: ReviewTemplateTypeType.review360,
    })
  ).filter(review => {
    const isCurrentUserCompiler = ReviewsUtils.isCurrentUserCompiler({ review, currentUserSlug: currentUser.slug });
    const isCurrentUserReceiver = ReviewsUtils.isCurrentUserReceiver({ review, currentUserSlug: currentUser.slug });
    const isCurrentUserCreator = ReviewsUtils.isCurrentUserCreator({ review, currentUserSlug: currentUser.slug });

    return isCurrentUserCompiler || isCurrentUserReceiver || isCurrentUserCreator;
  });

  const showSharedReviews = sharedAndCompletedReviews.size > 0;

  const baseClassName = 'PastReviews';

  return (
    <div className={baseClassName}>
      <CoachingPageHeader title="Past 360 Feedback" description="Safe place for your past feedback" size="lg" />
      <div className={`${baseClassName}__review_cards__list`}>
        {showSharedReviews ? (
          <ReviewsCardsContainer reviews={sharedAndCompletedReviews} />
        ) : (
          <EmptyStateContainer subTitle="No past feedback" inContainer />
        )}
      </div>
    </div>
  );
};

export default PastReviews;
